import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { IndividualAppointments } from "@/features/individuals/components/individual-appointments"
import { appointmentQueries } from "@/queries/appointments"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId/appointments/"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      appointmentQueries.listForIndividual(params.individualId)
    ),
  component: IndividualAppointmentsPage,
})

function IndividualAppointmentsPage() {
  const { individualId } = Route.useParams()

  return (
    <>
      <PageHeader title="Appointments" />
      <IndividualAppointments individualId={individualId} />
    </>
  )
}
